(function () {
  'use strict';

  function initFaqAccordion() {
    var items = document.querySelectorAll('[data-aom-faq]');
    if (!items.length) return;

    items.forEach(function (item) {
      var btn = item.querySelector('.aom-hp-faq-item__q');
      var answer = item.querySelector('.aom-hp-faq-item__a');
      if (!btn || !answer) return;

      btn.addEventListener('click', function () {
        var isExpanded = btn.getAttribute('aria-expanded') === 'true';

        // Close all siblings first
        items.forEach(function (sibling) {
          var sibBtn = sibling.querySelector('.aom-hp-faq-item__q');
          var sibAns = sibling.querySelector('.aom-hp-faq-item__a');
          if (sibBtn && sibAns) {
            sibBtn.setAttribute('aria-expanded', 'false');
            sibAns.hidden = true;
          }
        });

        // Toggle the clicked one
        if (!isExpanded) {
          btn.setAttribute('aria-expanded', 'true');
          answer.hidden = false;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaqAccordion);
  } else {
    initFaqAccordion();
  }
})();

/* ══════════════════════════════════════════════════════════════
   Quick-view modal — Featured Utility section
   ══════════════════════════════════════════════════════════════ */
(function initQuickViewModals() {

  /* ── Open ──────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-aom-qv-trigger]');
    if (!trigger) return;
    var modal = document.getElementById(trigger.dataset.aomQvTrigger);
    if (!modal) return;
    if (modal.open) return;
    /* Close any other open modal first */
    var alreadyOpen = document.querySelector('.aom-qv-modal[open]');
    if (alreadyOpen && alreadyOpen !== modal) {
      alreadyOpen.close();
    }
    try {
      modal.showModal();
      document.body.style.overflow = 'hidden';
    } catch (err) {
      /* showModal() failed — silently ignore (e.g., dialog not connected) */
    }
  });

  /* Keyboard: allow Enter / Space on focusable triggers */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var trigger = document.activeElement && document.activeElement.closest('[data-aom-qv-trigger]');
    if (!trigger) return;
    e.preventDefault();
    trigger.click();
  });

  /* ── Close button ──────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('.aom-qv-close');
    if (!closeBtn) return;
    var modal = closeBtn.closest('.aom-qv-modal');
    if (modal) {
      modal.close();
      document.body.style.overflow = '';
    }
  });

  /* ── Backdrop click ────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    if (!e.target.classList || !e.target.classList.contains('aom-qv-modal')) return;
    var rect = e.target.getBoundingClientRect();
    var outside =
      e.clientX < rect.left  ||
      e.clientX > rect.right ||
      e.clientY < rect.top   ||
      e.clientY > rect.bottom;
    if (outside) {
      e.target.close();
      document.body.style.overflow = '';
    }
  });

  /* ── Escape key ────────────────────────────────────────────── */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.aom-qv-modal[open]');
    if (open) {
      open.addEventListener('close', function once() {
        document.body.style.overflow = '';
        open.removeEventListener('close', once);
      });
    }
  });

  /* ── Thumbnail gallery ─────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-aom-qv-src]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-aom-qv-gallery]');
    if (!gallery) return;
    var mainImg = gallery.querySelector('.aom-qv-main-img');
    var newSrc  = thumb.dataset.aomQvSrc;
    if (!mainImg || !newSrc) return;

    mainImg.style.opacity = '0';
    mainImg.addEventListener('transitionend', function once() {
      mainImg.onload = function () {
        mainImg.style.opacity = '1';
        mainImg.onload = null;
      };
      mainImg.src = newSrc;
      mainImg.removeEventListener('transitionend', once);
    });

    gallery.querySelectorAll('[data-aom-qv-src]').forEach(function (t) {
      t.classList.toggle('aom-qv-thumb-active', t === thumb);
    });
  });

})();
